import React, { Fragment } from "react";

import Toolbar from "react-big-calendar/lib/Toolbar";

import {
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";

import LeftArrowIcon from "@material-ui/icons/ArrowLeft";
import RightArrowIcon from "@material-ui/icons/ArrowRight";

class CalendarToolbar extends Toolbar {
  render() {
    return (
      <Fragment>
        <Typography
          variant="h4line"
          style={{
            textTransform: "capitalize",
            width: "100%",
            textAlign: "center",
          }}
        >
          {this.props.label}
        </Typography>

        <div style={{ width: "100%", textAlign: "right" }}>
          <Button
            color="primary"
            onClick={() => this.props.onNavigate("TODAY")}
          >
            {this.props.localizer.messages.today}
          </Button>

          <IconButton onClick={() => this.props.onNavigate("PREV")}>
            <LeftArrowIcon />
          </IconButton>
          <IconButton onClick={() => this.props.onNavigate("NEXT")}>
            <RightArrowIcon />
          </IconButton>

          <FormControl style={{ marginLeft: 16 }}>
            <Select
              value={this.props.view}
              onChange={(e) => this.props.onView(e.target.value)}
            >
              {this.props.views.map((value, i) => (
                <MenuItem key={i} value={value}>
                  {this.props.localizer.messages[value]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </Fragment>
    );
  }
}

export default CalendarToolbar;



// WEBPACK FOOTER //
// ./src/components/CalendarToolbar.js